<template>
  <v-card elevation="0">
    <v-card-title
      v-if="mode === '_installation_' || mode === '_historique_perf_'"
    >
      <v-icon class="mr-2"> mdi-heart-pulse </v-icon>
      {{ $t("_evolution_de_la_performance_") }}
    </v-card-title>
    <hr v-if="mode === '_installation_' || mode === '_historique_perf_'" />
    <v-card-text
      v-if="
        (mode === '_installation_' || mode === '_historique_perf_') &&
        installation['pr_heliocity'] !== undefined
      "
    >
      <v-row>
        <div class="col">
          <h2 class="mb-2">
            <b> {{ installation["pr_heliocity"].toFixed(1) }} % </b>
          </h2>
          <div class="gray--text">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  {{ $t("_pr_heliocity_") }}
                </span>
              </template>
              <span>
                {{ $t("_pr_heliocity_hover_") }}
              </span>
            </v-tooltip>
          </div>
        </div>
        <div class="col">
          <h2 class="mb-2">
            <b> {{ installation["ip"].toFixed(1) }} % </b>
          </h2>
          <div class="gray--text">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  {{ $t("_ip_") }}
                </span>
              </template>
              <span>
                {{ $t("_ip_hover_") }}
              </span>
            </v-tooltip>
          </div>
        </div>
        <div class="col">
          <h2 class="mb-2">
            <b> {{ installation["reliability_score_f"].toFixed(0) }} / 5</b>
          </h2>
          <div class="gray--text">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  {{ $t("_indice_fiabilite_") }}
                </span>
              </template>
              <span>
                {{ $t("_indice_fiabilite_hover_") }}
              </span>
            </v-tooltip>
          </div>
        </div>
      </v-row>
    </v-card-text>
    <hr v-if="mode === '_installation_' || mode === '_historique_perf_'" />

    <v-card-text>
      <div
        class="d-flex justify-space-between align-center"
        style="width: 100%"
      >
        <!-- Graph type  -->
        <v-radio-group v-model="form.selectedFieldsOption" row>
          <div
            style="cursor: pointer"
            v-for="(option, key) in selectableFormFieldsOptions"
            :key="key"
          >
            <v-radio :label="option" :value="key"></v-radio>
          </div>
        </v-radio-group>

        <!-- Timestep  -->
        <span>
          <select v-model="timestep">
            <option
              v-for="timestepOption in timestepOptions"
              :value="timestepOption.value"
              :key="timestepOption.value"
            >
              {{ timestepOption.label }}
            </option>
          </select>
        </span>
      </div>

      <!-- Graph  -->
      <plotly-graph
        v-if="Object.keys(graph_data_master).length > 0"
        :key="graph_key"
        :dates="dates"
        :graph_data="graph_data_master"
        style="padding: 20px"
      />
      <LoadingDialog v-if="loading" :is_loading="loading"></LoadingDialog>
    </v-card-text>
  </v-card>
</template>

<script>
import api from "@/api/api.js";

import PlotlyGraph from "../../components/Plotly/PlotlyGraph";
import LoadingDialog from "@/components/Utils/LoadingDialog";
import cd from "@/utils/compute_data.js";

export default {
  components: {
    PlotlyGraph,
    LoadingDialog,
  },

  props: {
    mode: String,
    installation: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: false,

      form: {
        selectedFieldsOption: "",
      },

      formFieldsOptions: {},
      unity: "KWh",
      timestep: "weekly",
      pdm_graph_data: {},
      graph_data_master: {},
      mode_inv_mpp: "",
      showGraph: 0,
      graph_key: 0,

      site: undefined,
    };
  },

  computed: {
    timestepOptions() {
      const diffTime = Math.abs(
        new Date(this.dates.start) - new Date(this.dates.end)
      );
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      return [
        {
          label: this.$t("_donnees_brutes_"),
          value: "raw",
          active: diffDays <= 7,
        },
        {
          label: this.$t("_heure_"),
          value: "hourly",
          active: diffDays <= 30,
        },
        {
          label: this.$t("_journee_"),
          value: "daily",
          active: true,
        },
        {
          label: this.$t("_semaine_"),
          value: "weekly",
          active: true,
        },
        {
          label: this.$t("_mois_"),
          value: "monthly",
          active: true,
        },
        {
          label: this.$t("_annee_"),
          value: "yearly",
          active: true,
        },
      ].filter((t) => t.active);
    },

    dates() {
      return this.$store.state.parametersStore.dates;
    },

    installations() {
      return this.$store.getters.installations;
    },

    selectableFormFieldsOptions() {
      return Object.keys(this.formFieldsOptions).reduce((obj, key) => {
        obj[key] = this.formFieldsOptions[key];
        return obj;
      }, {});
    },
  },

  watch: {
    "$route.params.id": {
      handler: function () {
        this.refreshPage();
      },
      immediate: true,
    },

    "$root.$i18n.locale": {
      handler() {
        this.refreshPage();
        this.updateGraphType();
        this.graph_key += 1;
      },
      immediate: true,
    },

    dates: {
      handler() {
        this.checkgoodperiode();
        this.graph_key += 1;
      },
      deep: true,
    },

    timestep: {
      handler() {
        this.$store.dispatch("setGeoTimeStep", { timestep: this.timestep });
        this.updateGraphType();
        this.graph_key += 1;
      },
      deep: true,
    },

    mode: {
      handler() {
        this.graph_data_master = {};
        // this.$store.dispatch("setGeoPdm", {pdm_list: ''});
        this.updateGraphType();
        this.graph_key += 1;
      },
      deep: true,
    },

    "$store.getters.geo_pdm": {
      handler() {
        if (
          this.mode === "_vue_geometrique_" ||
          this.mode === "_vue_onduleurs_"
        ) {
          if (this.$store.getters.geo_pdm.length > 0) {
            this.renderSubarrayGraph();
          } else {
            this.graph_data_master = {};
          }
        }
        this.graph_key += 1;
      },
      immediate: true,
    },

    form: {
      handler() {
        this.updateGraphType();
        this.graph_key += 1;
      },
      deep: true,
    },
  },

  methods: {
    checkgoodperiode() {
      const diffTime = Math.abs(
        new Date(this.dates.start) - new Date(this.dates.end)
      );
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (this.timestep == "hourly") {
        if (diffDays > 30) {
          this.timestep = "daily";
          this.updateGraphType();
        } else {
          this.updateGraphType();
        }
      } else if (this.timestep == "raw") {
        if (diffDays > 7 && diffDays <= 30) {
          this.timestep = "hourly";
          this.updateGraphType();
        } else if (diffDays > 30) {
          this.timestep = "daily";
          this.updateGraphType();
        } else {
          this.updateGraphType();
        }
      } else {
        this.updateGraphType();
      }
    },

    isDcAnalysis() {
      return this.$store.getters.installations.find(
        (x) => x.id == this.$route.params.id
      ).dc_analysis;
    },

    getMenu() {
      return this.$store.getters.installations.find(
        (x) => x.id == this.$route.params.id
      )?.target_menu;
    },

    getSite() {
      this.site = this.$store.getters.installations.find(
        (x) => x.id == this.$route.params.id
      );
    },

    refreshPage() {
      if (this.isDcAnalysis()) {
        this.formFieldsOptions = {
          edc: this.$t("_energie_dc_"),
          eac: this.$t("_energie_ac_"),
          ip: this.$t("_ip_"),
          pr: this.$t("_pr_"),
        };
        this.form.selectedFieldsOption = "edc";
      } else {
        this.formFieldsOptions = {
          eac: this.$t("_energie_ac_"),
          ip: this.$t("_ip_"),
          pr: this.$t("_pr_"),
        };
        this.form.selectedFieldsOption = "eac";
      }

      if (this.mode === "_installation_" || this.mode === "_historique_perf_") {
        this.getSite();
        this.renderDashboardGraph("dashboard", this.form.selectedFieldsOption);
      }
    },

    updateGraphType() {
      // console.log('updateGraphType')
      this.getSite();
      if (this.site !== undefined) {
        if (
          this.mode === "_installation_" ||
          this.mode === "_historique_perf_"
        ) {
          this.renderDashboardGraph(
            "dashboard",
            this.form.selectedFieldsOption
          );
        } else if (
          this.mode === "_vue_geometrique_" &&
          this.$store.getters.geo_pdm !== null &&
          this.$store.getters.geo_pdm.length > 0
        ) {
          this.renderSubarrayGraph();
        } else if (
          this.mode === "_vue_onduleurs_" &&
          this.$store.getters.geo_pdm !== null &&
          this.$store.getters.geo_pdm.length > 0
        ) {
          this.renderSubarrayGraph();
        }
      }
    },

    async renderDashboardGraph(type, model) {
      this.loading = true;
      this.graph_data_master = {};
      let graphs = null;

      await api.getReportFullName(`${type}-${model}`, "").then((res_mod) => {
        graphs = res_mod.data;
      });

      this.query_param = {};
      this.query_param["installation_id"] = this.installation.id;
      this.query_param["start_date"] = this.dates.start;
      this.query_param["end_date"] = this.dates.end;
      this.query_param["date_interval"] = this.timestep;
      this.query_param["sel_pdm"] = null;
      this.query_param["export_type"] = null;
      this.query_param["pacgrid"] =
        this.installation.elec_var.includes("Pac@grid");
      if (graphs !== undefined) {
        await api
          .getTemplateRenderByName(
            graphs[0][1],
            this.$root.$i18n.locale,
            this.query_param
          )
          .then((res) => {
            this.graph_data_master = {
              data_render: res.data.data,
              layout_render: res.data.layout,
            };
          });
        this.loading = false;
      }
    },

    async renderSubarrayGraph() {
      if (this.$store.getters.geo_pdm === null) return;
      if (this.$store.getters.geo_pdm.length === 0) return;

      this.loading = true;
      this.graph_data_master = {};
      this.pdm_graph_data = {};
      this.mode_inv_mpp = "";
      const pdm_list_key = this.$store.getters.geo_pdm
        .split(",")
        .map((pdm) => cd.parsePdmId(pdm))
        .join(",");

      if (this.mode === "_vue_onduleurs_") {
        this.mode_inv_mpp = "inv";
      } else {
        this.mode_inv_mpp = "mpp";
      }
      await api
        .getInstallationSubarrayGraph(
          this.$route.params.id,
          this.$root.$i18n.locale,
          {
            start_date: this.dates.start,
            end_date: this.dates.end,
            time_step: this.timestep,
            pdm_list: pdm_list_key,
            export_type: "3D_pdm_datetime",
            pn_type: this.mode_inv_mpp,
          }
        )
        .then((res) => {
          this.pdm_graph_data = res.data;

          setTimeout(() => {
            this.getGraphData();
          }, 100);
        });

      this.loading = false;
    },

    getGraphData() {
      let options = [this.form.selectedFieldsOption];
      let scatters = [];
      let legend = {
        title: "",
        xaxis: {
          type: "date",
          title: {
            text: this.$t("_dates_"),
          },
          autorange: true,
          titlefont: {
            size: 18,
            color: "grey",
            family: "Arial, sans-serif",
          },
        },
        yaxis: {
          title: {
            text: "",
          },
          titlefont: {
            size: 18,
            color: "grey",
            family: "Arial, sans-serif",
          },
          autotick: true,
          position: 0,
          autorange: "true",
          rangemode: "tozero",
        },
        yaxis2: {
          side: "right",
          color: "orange",
          title: {
            text: this.$t("_solar_irr_(kwh)_"),
            standoff: 20,
          },
          titlefont: {
            size: 18,
            color: "grey",
            family: "Arial, sans-serif",
          },
          position: 1,
          rangemode: "tozero",
          overlaying: "y",
        },
        hovermode: "closest",
        legend: {
          anchor: "right",
          x: 1.1,
        },
        legenditem: {
          marker: {
            opacity: "0.25",
          },
        },
      };

      let currentOptions = options.slice();
      if (
        currentOptions.includes("edc") ||
        currentOptions.includes("eac") ||
        currentOptions.includes("ip") ||
        currentOptions.includes("pr")
      ) {
        currentOptions.push("ei");
      }

      if (currentOptions.includes("edc")) {
        currentOptions.push("edc_sim");
        legend.title =
          "<b>" +
          this.$t("_energie_dc_de_l_installation_solaire_en_%_") +
          "</b>";
        legend.yaxis.title.text = this.$t("_edc_(kwh)_");
      }

      if (currentOptions.includes("eac")) {
        currentOptions.push("eac_sim");
        legend.title =
          "<b>" +
          this.$t("_energie_ac_de_l_installation_solaire_en_%_") +
          "</b>";
        legend.yaxis.title.text = this.$t("_eac_(kwh)_");
      }

      if (currentOptions.includes("ip")) {
        legend.title =
          "<b>" +
          this.$t("_evolution_ip_de_l_installation_solaire_en_%_") +
          "</b>";
        legend.yaxis.title.text = this.$t("_indice_de_performance_en_%_");
      }

      if (currentOptions.includes("pr")) {
        legend.title =
          "<b>" +
          this.$t("_evolution_pr_de_l_installation_solaire_en_%_") +
          "</b>";
        legend.yaxis.title.text = this.$t("_performance_ratio_en_%_");
      }

      if (currentOptions.length === 0) return;

      if (
        this.mode === "_vue_geometrique_" ||
        this.mode === "_vue_onduleurs_"
      ) {
        const pdm_list = Object.keys(this.pdm_graph_data[currentOptions[0]]);

        // console.log(pdm_list)

        pdm_list.forEach((pdm) => {
          currentOptions.forEach((option) => {
            const pdm_data = this.pdm_graph_data[option][pdm];

            if (
              option !== "ei" &&
              option !== "eac_sim" &&
              option !== "edc_sim"
            ) {
              let option_title;
              if (option.includes("_sim")) {
                option_title = (
                  option.charAt(0).toUpperCase() + option.slice(1)
                ).replace("_sim", " modèle");
              } else {
                option_title = option.charAt(0).toUpperCase() + option.slice(1);
              }

              if (
                option == "ei" ||
                option.includes("eac") ||
                option.includes("edc")
              ) {
                this.unity = "KWh";
              } else {
                this.unity = "%";
              }

              scatters.push({
                x: Object.keys(pdm_data ? pdm_data : {}),
                y: Object.values(pdm_data ? pdm_data : {}),
                name: `${pdm} - ${option_title}`,
                id: `${pdm} - ${option}`,
                type: "scatter",
                mode: "lines+markers",
                hovertemplate: `<b>${pdm} - ${option_title} - %{x} - %{y:.1f} ${this.unity}</b><extra></extra>`,
              });
            }
          });
        });

        // // Push Ei graph
        // const ei = this.pdm_graph_data['ei'][pdm_list[0]]
        // scatters.push({
        //   x: Object.keys(ei ? ei : {}),
        //   y: Object.values(ei ? ei : {}),
        //   name: 'Irr. incidente',
        //   id: 'ei',
        //   type: "scatter",
        //   mode: "lines",
        //   line: {
        //     "dash": "dot",
        //     "color": "orange"
        //   },
        //   xaxis: "x",
        //   yaxis: "y2"
        // })
      }

      this.graph_data_master = {
        data_render: this.$_.uniqBy(scatters, "id"),
        layout_render: legend,
      };
    },
  },
};
</script>

<style scoped>
.v-text-field__details,
.v-messages {
  display: none;
}
select {
  background-color: #eef1f8;
  border-radius: 20px;
  border: none;
  padding-top: 4px;
  padding-bottom: 4px;
  height: 100%;
  max-width: 100%;
}
</style>
